import Vue from 'vue';
import Component from 'vue-class-component';

import BbGoogleMapLoader from 'common/components/Map/BBGoogleMapLoader';
import BbGoogleMapInfoWindow from 'common/components/Map/BbGoogleMapInfoWindow';
import BbGoogleMapCircleRadius from 'common/components/Map/BbGoogleMapCircleRadius';

import GoogleApiKeyQuery from 'common/graphql/queries/GoogleApiKey.graphql';
import { InfoWindow } from './Objects';

@Component({
  apollo: {
    apiKey: GoogleApiKeyQuery,
  },
  props: {
    markers: {
      required: true,
      type: Array,
    },
    infoWindow: {
      type: InfoWindow,
      default: null,
    },
    showInfoBegining: {
      type: Boolean,
      required: false,
    },
  },
  components: {
    BbGoogleMapLoader,
    BbGoogleMapInfoWindow,
    BbGoogleMapCircleRadius,
  },
})
export default class BbMapComponent extends Vue {
  DEFAULT_ZOOM = 14;
  center = {
    lat: 0,
    lng: 0,
  };
  NIGTHSTYLE = [
    { elementType: 'geometry', stylers: [{ color: '#242f3e' }] },
    { elementType: 'labels.text.stroke', stylers: [{ color: '#242f3e' }] },
    { elementType: 'labels.text.fill', stylers: [{ color: '#746855' }] },
    {
      featureType: 'administrative.locality',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#d59563' }],
    },
    {
      featureType: 'poi',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#d59563' }],
    },
    {
      featureType: 'poi.park',
      elementType: 'geometry',
      stylers: [{ color: '#263c3f' }],
    },
    {
      featureType: 'poi.park',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#6b9a76' }],
    },
    {
      featureType: 'road',
      elementType: 'geometry',
      stylers: [{ color: '#38414e' }],
    },
    {
      featureType: 'road',
      elementType: 'geometry.stroke',
      stylers: [{ color: '#212a37' }],
    },
    {
      featureType: 'road',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#9ca5b3' }],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry',
      stylers: [{ color: '#746855' }],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.stroke',
      stylers: [{ color: '#1f2835' }],
    },
    {
      featureType: 'road.highway',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#f3d19c' }],
    },
    {
      featureType: 'transit',
      elementType: 'geometry',
      stylers: [{ color: '#2f3948' }],
    },
    {
      featureType: 'transit.station',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#d59563' }],
    },
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [{ color: '#17263c' }],
    },
    {
      featureType: 'water',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#515c6d' }],
    },
    {
      featureType: 'water',
      elementType: 'labels.text.stroke',
      stylers: [{ color: '#17263c' }],
    },
  ];
  STYLES = [
    {
      featureType: 'poi',
      stylers: [
        {
          color: '#EAEAEA',
        },
        {
          lightness: 17,
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'geometry',
      stylers: [
        {
          color: '#EAEAEA',
        },
        {
          lightness: 20,
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#ffffff',
        },
        {
          lightness: 17,
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'geometry.stroke',
      stylers: [
        {
          color: '#ffffff',
        },
        {
          lightness: 29,
        },
        {
          weight: 0.2,
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'geometry',
      stylers: [
        {
          color: '#ffffff',
        },
        {
          lightness: 18,
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'geometry',
      stylers: [
        {
          color: '#ffffff',
        },
        {
          lightness: 16,
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'geometry',
      stylers: [
        {
          color: '#f5f5f5',
        },
        {
          lightness: 21,
        },
      ],
    },
    {
      featureType: 'poi.park',
      elementType: 'geometry',
      stylers: [
        {
          color: '#dedede',
        },
        {
          lightness: 21,
        },
      ],
    },
    {
      elementType: 'labels.text.stroke',
      stylers: [
        {
          visibility: 'on',
        },
        {
          color: '#ffffff',
        },
        {
          lightness: 16,
        },
      ],
    },
    {
      elementType: 'labels.text.fill',
      stylers: [
        {
          saturation: 36,
        },
        {
          color: '#333333',
        },
        {
          lightness: 40,
        },
      ],
    },
    {
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'transit',
      elementType: 'geometry',
      stylers: [
        {
          color: '#f2f2f2',
        },
        {
          lightness: 19,
        },
      ],
    },
    {
      featureType: 'administrative',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#fefefe',
        },
        {
          lightness: 20,
        },
      ],
    },
    {
      featureType: 'administrative',
      elementType: 'geometry.stroke',
      stylers: [
        {
          color: '#fefefe',
        },
        {
          lightness: 17,
        },
        {
          weight: 1.2,
        },
      ],
    },
  ];
  mapsConfig = {
    center: this.center,
    fullscreenControl: window.innerWidth > 480,
    gestureHandling: 'greedy',
    mapTypeControl: false,
    styles: this.isDaytime() ? this.STYLES : this.NIGTHSTYLE,
    zoom: this.DEFAULT_ZOOM,
  };

  created() {
    const latitudes = this.markers.map(marker => marker.position.lat);
    const longitudes = this.markers.map(marker => marker.position.lng);
    this.center = {
      lat: (Math.max(...latitudes) + Math.min(...latitudes)) / 2,
      lng: (Math.max(...longitudes) + Math.min(...longitudes)) / 2,
    };
  }

  /**
   * Change the map style to dark mode in chase the hour is not between the Daytime.
   *
   * @returns {boolean}
   */
  isDaytime() {
    const hour = new Date().getHours();
    const end = 18;
    const start = 6;

    return end >= hour && start <= hour;
  }
}
